module.exports = __webpack_public_path__ + "img/coming-soon.a7dba7a8.jpg";